import { css } from 'emotion';
import theme from '@lyearn-team/theme-config';

export const channelRoot = isDarkTheme => css`
  width: 100%;
  height: 100vh;
  z-index: 100;
  background-color: ${isDarkTheme ? theme.color.dark.saturn : theme.color.dark.white};

  .channel-content {
    height: 100%;
    display: flex;
    flex-direction: column;

    .channel-header {
      .content-type {
        display: inline-block;
        margin-left: 74px;
        font-size: 20px;
        font-weight: bold;
        line-height: 1.4;
        color: ${theme.color.dark.copper};
      }

      @media (max-width: 767px) {
        .content-type {
          display: none;
        }
      }
    }

    .channel-card-content {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
  }
`;
